import { useAppDispatch, useAppSelector } from 'appState/store'
import { ToggleSwitch } from 'components/Forms'
import { toggleArchivedView } from 'features/claims/claimsSlice'
import styled from 'styled-components'

export const ClaimsPageHeader = () => {
  const dispatch = useAppDispatch()
  const viewArchivedClaims = useAppSelector((state) => state.claims.viewArchivedClaims)

  const handleToggleView = (showArchived: boolean) => {
    dispatch(toggleArchivedView(showArchived))
  }

  return (
    <Div data-testid="claims-page-header">
      <h1>Claims</h1>
      <HeaderActions>
        <ToggleSwitch
          isChecked={viewArchivedClaims || false}
          onChange={handleToggleView}
          leftLabel="Active"
          rightLabel="Archived"
          size="medium"
        />
      </HeaderActions>
    </Div>
  )
}

const Div = styled.div`
  height: ${({ theme }) => theme.constants.pageTitleHeight};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0rem ${({ theme }) => theme.spacing.l};
  background: ${({ theme }) => theme.colors.neutral.lighter};
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey.lighter};
  margin-bottom: ${({ theme }) => theme.spacing.l};
  h1 {
    ${({ theme }) => theme.typography.h4.bold};
    color: ${({ theme }) => theme.colors.primary.neutral};
    padding-block: 0.75rem;
  }
  .back-btn {
    color: ${({ theme }) => theme.colors.primary.neutral};
  }
  /* button.export-btn {
    border: none;
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    ${({ theme }) => theme.typography.s.normal};
    color: ${({ theme }) => theme.colors.info.darker};
    margin-right: 1rem;

    &:hover {
      background: ${({ theme }) => theme.colors.secondary.lightest};
    }

    
  } */
`

const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.s};
`
